import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const RandomIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 25 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.27856 5.25004H0.892855C0.399776 5.25004 0 4.85826 0 4.37504C0 3.89183 0.399776 3.50005 0.892855 3.50005H5.27856C7.29217 3.50005 9.19395 4.45882 10.3645 6.06488L11.4027 7.48916L10.3053 8.99459L8.91136 7.08207C8.07543 5.93495 6.7174 5.25004 5.27856 5.25004ZM24.7383 16.0064L21.1669 12.5064C20.818 12.1645 20.2531 12.1645 19.9044 12.5064C19.5558 12.8483 19.5555 13.402 19.9044 13.7436L21.9517 15.75H19.7214C18.2828 15.75 16.9247 15.0651 16.0886 13.918L14.6946 12.0055L13.5973 13.5109L14.6355 14.9352C15.806 16.5412 17.7075 17.5 19.7214 17.5H21.9517L19.9044 19.5064C19.5555 19.8483 19.5555 20.4019 19.9044 20.7436C20.0787 20.9145 20.3073 21 20.5357 21C20.764 21 20.9926 20.9145 21.1669 20.7436L24.7383 17.2436C25.0872 16.9019 25.0872 16.3481 24.7383 16.0064ZM24.7383 3.75642L21.1669 0.256429C20.818 -0.0854763 20.2531 -0.0854763 19.9044 0.256429C19.5558 0.598334 19.5555 1.15199 19.9044 1.49368L21.9517 3.50005H19.7214C17.7078 3.50005 15.806 4.45882 14.635 6.06532L8.91203 13.9176C8.07543 15.0651 6.7174 15.75 5.27856 15.75H0.892855C0.399776 15.75 0 16.1418 0 16.625C0 17.1082 0.399776 17.5 0.892855 17.5H5.27856C7.29217 17.5 9.19395 16.5412 10.3649 14.9347L16.0879 7.0825C16.9245 5.93495 18.2825 5.25004 19.7214 5.25004H21.9517L19.9044 7.25641C19.5555 7.59832 19.5555 8.15197 19.9044 8.49366C20.0787 8.6645 20.3073 8.75003 20.5357 8.75003C20.764 8.75003 20.9926 8.6645 21.1669 8.49366L24.7383 4.99367C25.0872 4.65198 25.0872 4.09811 24.7383 3.75642Z"
        fill="currentColor"
      />
    </svg>
  )
})

RandomIcon.displayName = 'RandomIcon'
